export function escHtml(str: string): string {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function isExpired(iso: string): boolean {
  return new Date(iso).getTime() < Date.now();
}

export function isSlackPermalink(url: string | undefined): boolean {
  if (!url) return false;
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:') return false;
    return u.hostname.endsWith('.slack.com') || u.hostname === 'slack.com' || u.hostname === 'app.slack.com';
  } catch {
    return false;
  }
}
